import { useSnapshot } from 'valtio'
import { hideCurrentModal, miscUiState } from '../../globalState'
import { options } from '../../optionsStorage'
import { RenderQualityField } from './RenderQualityField'
import {
  SegmentedField, SettingsDivider, SettingsScreen, SettingsSection, ToggleRow
} from './SettingsUi'

const FPS_OPTIONS = [
  { value: '24', label: '24' },
  { value: '30', label: '30' },
  { value: '60', label: '60' },
  { value: '120', label: '120' },
  { value: 'auto', label: 'Авто', splitBefore: true },
] as const

const CHUNK_DISTANCE_OPTIONS = [
  { value: '2', label: '2' },
  { value: '4', label: '4' },
  { value: '6', label: '6' },
  { value: '8', label: '8' },
] as const

export const RenderScreen = ({ canGoBack }: { canGoBack?: boolean }) => {
  const snapshot = useSnapshot(options)
  // Singleplayer keeps its own distance, same split the legacy screen used.
  const distanceId = miscUiState.singleplayer || !miscUiState.gameLoaded ? 'renderDistance' : 'multiplayerRenderDistance'

  return <SettingsScreen title='Рендер' onBack={canGoBack ? hideCurrentModal : undefined}>
    <RenderQualityField />
    <SegmentedField
      title='FPS'
      options={FPS_OPTIONS}
      value={snapshot.frameLimit === false ? 'auto' : String(snapshot.frameLimit)}
      onChange={value => {
        options.frameLimit = value === 'auto' ? false : Number(value)
      }}
    />
    <SegmentedField
      title='Дальность чанков'
      options={CHUNK_DISTANCE_OPTIONS}
      value={String(snapshot[distanceId])}
      onChange={value => {
        options[distanceId] = Number(value)
      }}
    />
    <ToggleRow
      label='Ограничить FPS в фоне'
      description='Снижает FPS, если окно не открыто'
      checked={snapshot.backgroundRendering !== 'full'}
      onChange={value => {
        options.backgroundRendering = value ? '20fps' : 'full'
      }}
    />
    <ToggleRow
      label='Режим экономии памяти'
      description='Могут появиться проблемы'
      checked={snapshot.lowMemoryMode}
      onChange={value => {
        options.lowMemoryMode = value
      }}
    />
    <SettingsDivider />
    <SettingsSection title='Мир'>
      {/* One switch for both lighting options, as noted on the mockup. */}
      <ToggleRow
        label='Плавное освещение'
        checked={snapshot.smoothLighting}
        onChange={value => {
          options.smoothLighting = value
          options.newVersionsLighting = value
        }}
      />
      <ToggleRow
        label='Показывать сущности'
        description='Мобы, игроки, предметы и другие объекты в мире'
        checked={snapshot.renderEntities}
        onChange={value => {
          options.renderEntities = value
        }}
      />
    </SettingsSection>
    <SettingsDivider />
    <SettingsSection title='Дополнительно'>
      <ToggleRow
        label='Цикл дня и ночи'
        description='Отображает смену суток в игре'
        checked={snapshot.dayCycleAndLighting}
        onChange={value => {
          options.dayCycleAndLighting = value
        }}
      />
      <ToggleRow
        label='Упрощение сущностей'
        description='Упрощает сундуки, таблички, кровати и другие сложные блоки'
        checked={snapshot.disableBlockEntityTextures}
        onChange={value => {
          options.disableBlockEntityTextures = value
        }}
      />
    </SettingsSection>
  </SettingsScreen>
}
